// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"4904dd08","697":"f31f44e9","979":"2dddfa68"}[chunkId] + ".chunk.js";
};